var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.isTool && !_vm.isUpload)?_c('ToolForm',_vm._b({},'ToolForm',_vm.toolParams,false)):(_vm.isWorkflow)?_c('WorkflowRun',_vm._b({},'WorkflowRun',_vm.workflowParams,false)):(_vm.isController)?_c('div',{attrs:{"src":_vm.controllerParams}}):_c('CenterFrame',{attrs:{"src":"/welcome"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }